@layer module {
.account-warning-wrapper {
            display: flex;
            flex-flow: column nowrap;
            align-items: flex-start;
            width: 100%;
    }

.account-warning-wrapper .account-warning-heading {
            text-align: center;
            width: 100%;
            display: flex;
            align-items: center;
            justify-items: flex-start;
    }
} // layer module










@layer app {
.account-warning-wrapper {
            padding: $size-20 0;
    }

.account-warning-wrapper .account-warning-heading {
            margin-bottom: $size-10;
    }

.account-warning-heading img, .account-warning-heading svg {
            margin-right: $size-10;
    }

.account-warning-wrapper {
            color: var(--banky-radical-red);
            font-size: var(--font-size-base);
            font-style: normal;
            font-weight: normal;
            line-height: $size-17;
    }

.account-warning-wrapper .account-warning-heading {
            color: var(--banky-radical-red);
            font-size: var(--font-size-lg);
            font-style: normal;
            font-weight: 600;
            line-height: $size-20;
    }
} // layer app
